import {environment} from '../../Environments/environment';



export class CordovaService {

  private _isTablet = false;
  static $inject = ['$q', '$timeout'];

  static serviceId = 'cordova';

  private appVersionValue = '1.0.0'; // Default version

  constructor(private $q: ng.IQService, private timeout: ng.ITimeoutService) {
    this.appVersionValue = environment.version;
  }

  get appVersion() {
    return Promise.resolve(this.appVersionValue);
  }

  get notification() {
    // Web API implementation of notification
    return {
      confirm: (message: string, callback: Function, title: string, buttonLabels: string[]) => {
        const result = confirm(message);
        callback(result ? 1 : 2);
      },
      alert: (message: string, callback: Function, title: string, buttonName: string) => {
        alert(message);
        callback();
      }
    };
  }

  get isTablet() {
    return this._isTablet;
  }

  get isIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  }

  get isAndroid() {
    return /Android/.test(navigator.userAgent);
  }

  evaluateDeviceType() {
    // Check if device is a tablet based on screen size
    const isTablet = window.innerWidth >= 768 && window.innerHeight >= 768;

    // Check user agent for iPad
    const isIpad = this.isOldIpad(window);

    // Check if Android tablet
    const isAndroidTablet = this.isAndroidTablet(window);

    this._isTablet = isTablet || isIpad || isAndroidTablet;
  }

  isAndroidTablet(win: Window) {
    return /Android/.test(win.navigator.userAgent) && !/Mobile/.test(win.navigator.userAgent);
  }

  isOldIpad(win: Window) {
    // iOS 12 and below
    if (this.testUserAgent(win, /iPad/i)) {
      return true;
    }

    // iOS 13+ iPad detection
    const isIOS = /iPad|iPhone|iPod/.test(win.navigator.userAgent) && !(win as any).MSStream;
    const isStandalone = (win.navigator as any).standalone;
    const isTabletSize = win.innerWidth >= 768 && win.innerHeight >= 768;

    return isIOS && isTabletSize;
  }

  testUserAgent(win: Window, expr: RegExp) {
    return expr.test(win.navigator.userAgent);
  }
}
